import { styled } from '@mui/material';
import React, { useState } from 'react';
import UnstyledButton from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/UnstyledFilterButton';
import _clone from 'lodash/clone';
import { EditInput } from 'src/components/BeaconV2Components/GenericSidebarNav/AdvertisingEditFields/EditInput';
import { SelectedIncludeCheckbox, SelectExcludeCheckbox, SelectIncludeCheckbox } from 'src/components/SvgIcons';
import { useAppSelector, useSnackbar } from 'src/utils/Hooks';

import { fetchMainEntity } from 'src/store/modules/entityService/operations';
import { useDispatch } from 'react-redux';
import { updatePortfolio } from 'src/components/AdManager/AmsUtils';
import { CustomLoading } from 'src/components/common/Loading/PlaceHolderLoading/PlaceHolderLoading';
import { fetchAdPortfolios } from 'src/store/modules/adManager/adPortfolios/operations';
import numeral from 'numeral';

const ButtonGroup = styled('div')({
  height: 18,
  width: 0,
  opacity: 0,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: 4,
  transition: 'all 0.3s ease-in',
  '&.focus': {
    overflow: 'hidden',
    width: 48,
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 4
  }
});

const PortfolioBudget = () => {
  const { showSnackbar } = useSnackbar();
  const [isFocus, setIsFocus] = useState(false);
  const currentEntity = useAppSelector((state) => state.entityService.mainEntity);

  const adPortfoliosData = useAppSelector((state) => state.adPortfoliosData);

  const mtdSpend = adPortfoliosData?.mtdSpend?.find((item) => item.fieldId === currentEntity.id)?.value || 0;

  const formattedMtdSpend = numeral(mtdSpend).format('$0,0');
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const currentBudget = currentEntity?.extendedAttributes?.liveBudgetSetting?.amount;
  const [budget, setBudet] = useState<string | undefined>();

  const saveBudget = async () => {
    if (!budget || +budget < mtdSpend) {
      showSnackbar({
        message: `Your new budget cannot be less than MTD ad spend ${formattedMtdSpend}. Please increase your budget.`,
        type: 'error'
      });
      return;
    }
    try {
      const mainEntityCloned: any = _clone(currentEntity);
      mainEntityCloned.extendedAttributes.currentMonthBudgetSetting.amount = +budget || 1;
      setLoading(true);
      setIsFocus(false);
      setBudet(undefined);
      await updatePortfolio(mainEntityCloned);
      await dispatch(
        fetchMainEntity(mainEntityCloned.type, mainEntityCloned.id, mainEntityCloned.extendedAttributes.retailerId)
      );
      await dispatch(fetchAdPortfolios());
      showSnackbar({
        message: 'Budget saved successfully.',
        type: 'success'
      });
      setBudet(undefined);
      setLoading(false);
    } catch (error) {
      showSnackbar({
        message: 'Error saving budget, please try again later.',
        type: 'error'
      });
      console.error('Error saving budget', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        className="field-title"
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '12px'
        }}
      >
        Monthly Budget
        <ButtonGroup className={isFocus ? 'focus' : ''}>
          <UnstyledButton onClick={() => {}}>
            {budget ? (
              <SelectedIncludeCheckbox onClick={saveBudget} style={{ width: '16px', height: '16px' }} />
            ) : (
              <SelectIncludeCheckbox style={{ width: '16px', height: '16px' }} />
            )}
          </UnstyledButton>
          <UnstyledButton
            onClick={() => {
              setIsFocus(false);
              setBudet(undefined);
            }}
          >
            <SelectExcludeCheckbox style={{ width: '16px', height: '16px' }} />
          </UnstyledButton>
        </ButtonGroup>
      </div>
      <div className="field-subtitle">
        {loading ? (
          <CustomLoading height={12} width={88} padding={0} />
        ) : (
          <EditInput
            onFocus={() => {
              setIsFocus(true);
            }}
            onBlur={() => {
              if (!budget || budget === currentBudget) {
                setIsFocus(false);
              }
            }}
            prefix="$"
            placeholder={currentBudget}
            value={budget}
            onChange={(e) => setBudet(e.target.value)}
          />
        )}
      </div>
    </div>
  );
};

export default PortfolioBudget;
